import { render, staticRenderFns } from "./platformPrice.vue?vue&type=template&id=68d57a03"
import script from "./platformPrice.vue?vue&type=script&lang=js"
export * from "./platformPrice.vue?vue&type=script&lang=js"
import style0 from "./platformPrice.vue?vue&type=style&index=0&id=68d57a03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports